import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// ---- Marketing forms ----
export const submitConsultation = (payload) => api.post("/consultation", payload).then((r) => r.data);
export const submitQuote = (payload) => api.post("/quote", payload).then((r) => r.data);

// ---- Auth ----
export const exchangeSession = (session_id) => api.post("/auth/session", { session_id }).then((r) => r.data);
export const fetchMe = () => api.get("/auth/me").then((r) => r.data);
export const logout = () => api.post("/auth/logout").then((r) => r.data);

// ---- Decks ----
export const listTemplates = () => api.get("/templates").then((r) => r.data);
export const listDecks = () => api.get("/decks").then((r) => r.data);
export const createDeck = (payload) => api.post("/decks", payload).then((r) => r.data);
export const getDeck = (id) => api.get(`/decks/${id}`).then((r) => r.data);
export const updateDeck = (id, payload) => api.put(`/decks/${id}`, payload).then((r) => r.data);
export const deleteDeck = (id) => api.delete(`/decks/${id}`).then((r) => r.data);
export const duplicateDeck = (id) => api.post(`/decks/${id}/duplicate`).then((r) => r.data);
export const deckComments = (id) => api.get(`/decks/${id}/comments`).then((r) => r.data);

// ---- Public deck viewer ----
export const getPublicDeck = (slug) => api.get(`/public/decks/${slug}`).then((r) => r.data);
export const listPublicComments = (slug) => api.get(`/public/decks/${slug}/comments`).then((r) => r.data);
export const addPublicComment = (slug, slide_id, payload) =>
  api.post(`/public/decks/${slug}/slides/${slide_id}/comments`, payload).then((r) => r.data);

// ---- Testimonials ----
export const listPublicTestimonials = () => api.get("/testimonials").then((r) => r.data);
export const adminListTestimonials = () => api.get("/admin/testimonials").then((r) => r.data);
export const adminCreateTestimonial = (payload) => api.post("/admin/testimonials", payload).then((r) => r.data);
export const adminUpdateTestimonial = (id, payload) => api.put(`/admin/testimonials/${id}`, payload).then((r) => r.data);
export const adminDeleteTestimonial = (id) => api.delete(`/admin/testimonials/${id}`).then((r) => r.data);
